import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BankConnectionWrapper = styled.div`
  padding: ${Spacing.S12};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.Grey100};
`

export const BankLogo = styled.img`
  border-radius: ${BorderRadius.R10};
  object-fit: contain;
`
